import { render, staticRenderFns } from "./BusinessStructureValidationDialog.vue?vue&type=template&id=970a2656&scoped=true&"
import script from "./BusinessStructureValidationDialog.vue?vue&type=script&lang=js&"
export * from "./BusinessStructureValidationDialog.vue?vue&type=script&lang=js&"
import style0 from "./BusinessStructureValidationDialog.vue?vue&type=style&index=0&id=970a2656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a2656",
  null
  
)

export default component.exports